import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/global.css";
import "./styles/screens.css";

const container = document.getElementById("root") as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The public routes ship PRERENDERED (scripts/prerender.mjs) — hydrate onto that HTML instead
// of re-rendering it. Two exceptions fall back to a clean client render: app.* (the prerendered
// apex homepage is the wrong tree there — "/" redirects to /ops) and any route the prerenderer
// didn't cover (SPA fallback serves the "/" HTML for e.g. /signin, where hydrating the home
// markup against the sign-in tree would mismatch).
const path = window.location.pathname.replace(/\/$/, "") || "/";
const PRERENDERED = new Set(["/", "/proof", "/terms", "/privacy"]);
const canHydrate =
  container.hasChildNodes() &&
  PRERENDERED.has(path) &&
  !window.location.hostname.startsWith("app.");

if (canHydrate) {
  hydrateRoot(container, app);
} else {
  container.innerHTML = "";
  createRoot(container).render(app);
}
